import type { ConsentParams, CookieCategories } from '../../constants';

const consentParamsToCategories = (
  consent: ConsentParams,
): Array<CookieCategories> => {
  const categories: Array<CookieCategories> = ['necessary'];

  if (consent.analytics_storage === 'granted') categories.push('analytics');

  return categories;
};

export default consentParamsToCategories;
